import { cookie } from "@/utils/cookie"

const COOKIE_NAME = "bk_utm"
const UTM_PARAMS = ["utm_campaign", "utm_source", "utm_medium", "utm_term", "utm_content"]

const getUtmParam = (paramName) => {
  try {
    const queryString = window.location.search

    const urlParams = new URLSearchParams(queryString)

    return urlParams.get(paramName)
  } catch (e) {
    return null
  }
}

export const trackUTMParams = () => {
  if (cookie(COOKIE_NAME)) {
    return
  }

  const utmParams = UTM_PARAMS.reduce((params, param) => {
    const value = getUtmParam(param)

    if (value) {
      params[param] = value
    }

    return params
  }, {})

  const utmParamsPresent = Object.values(utmParams).some((x) => !!x)

  if (utmParamsPresent) {
    cookie(COOKIE_NAME, encodeURIComponent(JSON.stringify(utmParams)), 14)
  }
}

export const readUTMParams = () => {
  try {
    return JSON.parse(decodeURIComponent(cookie(COOKIE_NAME)))
  } catch (e) {
    return {}
  }
}

export const appendUTMParams = (baseUrl) => {
  const utmParams = readUTMParams()

  if (!utmParams) {
    return baseUrl
  }

  var url = new URL(baseUrl)

  UTM_PARAMS.forEach((param) => {
    const value = utmParams[param]

    if (value) {
      url.searchParams.append(param, value)
    }
  })

  return url.toString()
}
